import { useCallback } from 'react';
import { vscodeWebApi } from '@/lib/api';
import { ConfirmDialog } from '@/components/ui-new/dialogs/ConfirmDialog';
import type { Project } from 'shared/types';

export function useOpenProjectInVscodeWeb(project: Project | null) {
  return useCallback(async (): Promise<void> => {
    if (!project) return;

    try {
      const response = await vscodeWebApi.verifyProjectWithCookie(project.id);

      // Open the URL in a new tab
      if (response.url) {
        window.open(response.url, '_blank');
      }
    } catch (err) {
      console.error('Failed to open project in VS Code Web:', err);
      const message =
        err && typeof err === 'object' && 'message' in err
          ? String(err.message)
          : 'Failed to open VS Code Web. Please check your configuration.';
      ConfirmDialog.show({
        title: 'Error',
        message,
        variant: 'destructive',
        confirmText: 'OK',
        showCancelButton: false,
      });
    }
  }, [project]);
}